<div *ngIf="translate.currentLang == 'lt'" class="card mt-3">
    <div class="card-body">
        <h5 class="m-2 ml-4 card-title">{{ 'Page_Details_Description' | translate | uppercase }}</h5>
        <div class="card-body text-justify custom__card_comment">
            {{ vehicle?.comment}}
        </div>
    </div>
</div>